import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useKeyboardShortcuts } from '../../hooks';

function BodyRow(_ref) {
  var innerRef = _ref.innerRef,
      placeholder = _ref.placeholder,
      rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      style = _ref.style,
      keyboardShortcuts = _ref.keyboardShortcuts,
      onRowClick = _ref.onRowClick,
      restProps = _objectWithoutPropertiesLoose(_ref, ["innerRef", "placeholder", "rowData", "rowIndex", "style", "keyboardShortcuts", "onRowClick"]);

  var Component = restProps.href ? 'a' : 'div';

  var _useKeyboardShortcuts = useKeyboardShortcuts(keyboardShortcuts, {
    rowData: rowData,
    rowIndex: rowIndex
  }),
      bindKeyboardShortcuts = _useKeyboardShortcuts.bindKeyboardShortcuts,
      unbindKeyboardShortcuts = _useKeyboardShortcuts.unbindKeyboardShortcuts;

  var props = _objectSpread({
    ref: innerRef,
    onClick: onRowClick && function () {
      return onRowClick(rowData, rowIndex);
    },
    onMouseEnter: bindKeyboardShortcuts,
    onMouseLeave: unbindKeyboardShortcuts,
    style: _objectSpread({
      opacity: placeholder ? 0.65 : undefined
    }, style)
  }, restProps);

  if (!restProps.href) {
    props.role = 'row';
  }

  return /*#__PURE__*/React.createElement(Component, props);
}

export default BodyRow;